import { OrderStatus, OrderType } from '@restaurant/types';

export const ORDER_STATUS_TEXT = {
  [OrderStatus.Refund]: 'Refund',
  [OrderStatus.Void]: 'Void',
  [OrderStatus.Open]: 'Open',
  [OrderStatus.Closed]: 'Closed',
};

export const ORDER_STATUS_OPTIONS = [
  OrderStatus.Open,
  OrderStatus.Closed,
  OrderStatus.Refund,
  OrderStatus.Void,
].map((value) => ({
  value,
  label: ORDER_STATUS_TEXT[value],
}));

export const ORDER_TYPE_TEXT = {
  [OrderType.DineIn]: 'Dine In',
  [OrderType.TakeAway]: 'Takeaway',
  [OrderType.Indent]: 'Indent',
};

export const ORDER_TYPE_OPTIONS = [
  OrderType.DineIn,
  OrderType.TakeAway,
  OrderType.Indent,
].map((value) => ({
  value,
  label: ORDER_TYPE_TEXT[value],
}));

export const checkIsRequireTableNumber = (val: OrderType) =>
  val === OrderType.DineIn;
